import axios from 'axios';
import { action, observable } from 'mobx';

class UserStore {

	@observable users = [];

	// this is the logged in user and should not be changed for editing
	// purposes. Just left it the name of user for less typing.
	@observable user = {
		user_id: 0,
		user_name: '',
		email: '',
		phone: '',
		role: '',
		account_id: 0,
		regions: [],
		registration_url: ''
	}

	getUsers(account_id) {
		let url = '/api/users';
		if (account_id) {
			url = '/api/accounts/' + account_id + '/users';
		}
		return axios.get(url).then((data) => {
			this.users.replace(data.data);
		})
	}

	createUser(user) {
		return axios.post('/api/users', user).then(action((data) => {
			this.users.push(data.data);
		}));
	}

	updateUser(user_id, user) {
		return axios.put('/api/users/' + user_id, user)
			.then(action((data) => {
				if (user_id === this.user.user_id) {
					for (let key in user) {
						if (key !== 'password') this.user[key] = user[key];
					}
				}
				// see if the user is in the current list of users
				// and update it's information
				for (let x=0; x < this.users.length; x++) {
					if (this.users[x].user_id === user_id) {
						for (let key in user) {
							if (key !== 'password') this.users[x][key] = user[key];
						}
						break;
					}
				}
				return data.data;
			}));
	}

	getUser(user_id) {
		return new Promise((resolve, reject) => {

			// see first if the user is in the current list of users
			for (let x=0; x < this.users.length; x++) {
				if (this.users[x].user_id === user_id) {
					return resolve(this.users[x]);
				}
			}

			// didn't find it in the current list, pull it from the server
			axios.get('/api/users/' + user_id).then((data) => {
				resolve(data.data);
			}).catch(reject);
		});
	}

	deleteUser(user) {
		return axios.delete('/api/users/' + user.user_id)
			.then(action((rslt) => this.users.remove(user)));
	}

}
const store = new UserStore();

export default store;



/** WEBPACK FOOTER **
 ** ./src/stores/UserStore.js
 **/